module.exports = __webpack_public_path__ + "static/es-f3cef83cf5c2b04e505e05e79392f298.svg";